import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing,
} from '../../../theme';

export const StyledOfferPerks = styled.div`
  margin: auto;
  max-width: ${container('xs')};
`;

export const StyledOfferPerksMain = styled.div`
  background-color: ${color('white')};
  border-radius: ${radius('md')};
  padding: ${spacing('md')};
  box-shadow: ${shadow('md')};
`;

export const StyledOfferPerksMainTitle = styled.h4`
  text-align: center;
  font-weight: ${fontWeight('black')};
  color: ${color('text_subtle')};
  text-transform: uppercase;
  font-size: ${fontSize('xs')};
  line-height: 1;
  margin-top: 0;
  margin-bottom: ${spacing('md')};
`;

export const StyledOfferPerksMainPerks = styled.div`
  @media (min-width: ${screen('md')}) {
    display: flex;
  }

  > * {
    @media (min-width: ${screen('md')}) {
      padding-left: ${spacing('xs')};
      padding-right: ${spacing('xs')};
      width: calc(50% - ${spacing('md')});
      flex-grow: 1;
    }
  }
`;

export const StyledOfferPerksExtra = styled.div`
  margin-top: ${spacing('lg')};

  > * {
    @media (min-width: ${screen('md')}) {
      padding-left: ${spacing('xl')};
      padding-right: ${spacing('xl')};
      margin-top: ${spacing('lg')};
    }
  }
`;
